/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {
    artists: {
        search: '',
        offset: 0,
        limit: 7
    },
    albums: {
        genreId: '',
        artistId: '',
        yearId: '',
        search: '',
        sortby: '',
        offset: 0,
        limit: 7
    },
    tracks: {
        albumId: '',
        genreId: '',
        artistId: '',
        yearId: '',
        search: '',
        sortby: '',
        offset: 0,
        limit: 7
    },
    playlist: {
        search: '',
        offset: 0,
        limit: 7
    },
    playlistTrack: {
        config: {
            search: '',
            offset: 0,
            limit: 7
        },
        list: {}
    },
    provider: {
        size: 7,
        pages: 2
    }
};
